import { useEffect, useState } from "react";
import Select from "../../../../../../components/Select";
import GenericSwitch from "../../../../../../components/GenericSwitch";
import ConfirmDelete from "../../../../../../components/ConfirmDelete";
import { getCamposEquipamento } from "../../../../../../services/equipamentos";
import helper from "../../../../../../utils/helper";

const CustomParamRow = ({ param, equipmentList, onChange, onDelete, onAdd, isNew = false, errors = {} }) => {
    const [fields, setFields] = useState([]);

    useEffect(() => {
        if (param?.equipment) {
            loadFields(param.equipment);
        }
    }, [param?.equipment]);

    const loadFields = async (equipmentId) => {
        if (!equipmentId) return;

        try {
            const resp = await getCamposEquipamento(equipmentId);
            setFields(resp || []);
        } catch (err) {
            console.error(err);
        }
    };

    const handleChange = (field, value) => {
        let newValue = value;

        if (field === "equipmentField") {
            newValue = value?.value;
        }

        onChange({
            ...param,
            [field]: newValue
        });
    };

    const handleEquipmentFieldCheck = (option) => {
        const wrongParamOperatorDayMessage = "O parâmetro selecionado não é compatível com o operador especial de Volume do Dia. Pode haver inconsistências nos cálculos.";

        const wrongParamOperatorMonthMessage = "O parâmetro selecionado não é compatível com o operador especial de Volume do Mês. Pode haver inconsistências nos cálculos.";

        if (param.groupBy === "dia" && option?.special_operator !== "volume_dia") {
            helper.dispatchEvent("showAviso", { message: wrongParamOperatorDayMessage });
        }

        if (param.groupBy === "mes" && option?.special_operator !== "volume_mes") {
            helper.dispatchEvent("showAviso", { message: wrongParamOperatorMonthMessage });
        }
    };

    const scaleOptions = [
        { value: "nenhuma", label: "Nenhuma" },
        { value: "minima", label: "Mínima" },
        { value: "media", label: "Média" },
        { value: "maxima", label: "Máxima" }
    ];

    const groupByOptions = [
        { value: "nenhum", label: "Nenhum" },
        { value: "dia", label: "Por Dia" },
        { value: "mes", label: "Por Mês" }
    ];

    const isDisabled = !isNew && !param.isActive;

    return (
        <div>
            {!isNew && (
                <div className="grant-custom-params__active">
                    <GenericSwitch
                        checked={param.isActive}
                        onChange={(value) => handleChange("isActive", value)}
                    />
                </div>
            )}
            <div className="grant-custom-params__wrapper">
                <div className={`grant-custom-params__row ${isDisabled ? "grant-custom-params__row--disabled" : ""}`}>
                    <div className="grant-custom-params__input">
                        <label>Nome</label>
                        <input
                            type="text"
                            placeholder="Nome"
                            value={param.name || ""}
                            disabled={isDisabled}
                            onChange={(e) => handleChange("name", e.target.value)}
                            className={errors?.name ? "has-error" : ""}
                        />
                    </div>

                    <div className="grant-custom-params__select">
                        <label>Equipamento</label>
                        <Select
                            placeholder="Selecione"
                            value={param.equipment}
                            options={equipmentList}
                            disabled={isDisabled}
                            onChange={(option) => handleChange("equipment", option?.value)}
                            hasError={errors?.equipment}
                            resolveValueFromOptions
                            isClearable={isNew}
                        />
                    </div>

                    <div className="grant-custom-params__select">
                        <label>Agrupamento</label>
                        <Select
                            placeholder="Selecione"
                            value={param.groupBy}
                            options={groupByOptions}
                            disabled={isDisabled}
                            onChange={(option) => handleChange("groupBy", option?.value)}
                            hasError={errors?.groupBy}
                            resolveValueFromOptions
                            isClearable={isNew}
                        />
                    </div>

                    <div className="grant-custom-params__select">
                        <label>Parâmetro</label>
                        <Select
                            placeholder="Selecione"
                            value={param.equipmentField}
                            options={fields}
                            disabled={isDisabled || !param.groupBy}
                            onChange={(option) => {
                                handleEquipmentFieldCheck(option);
                                handleChange("equipmentField", option);
                            }}
                            hasError={errors?.equipmentField}
                            resolveValueFromOptions
                            isClearable={isNew}
                        />
                    </div>

                    <div className="grant-custom-params__inputs__wrapper">
                        <div className="grant-custom-params__inputs__wrapper-input">
                            <label>Alerta (Início)</label>
                            <input
                                type="number"
                                placeholder="Alerta"
                                value={param.alertValueStart ?? ""}
                                disabled={isDisabled}
                                onChange={(e) => handleChange("alertValueStart", e.target.value)}
                                className={errors?.alertValueStart ? "has-error" : ""}
                            />
                        </div>
                        <i className="fa fa-arrow-right" />
                        <div className="grant-custom-params__inputs__wrapper-input">
                            <label>Alerta (Fim)</label>
                            <input
                                type="number"
                                placeholder="Alerta"
                                value={param.alertValueEnd ?? ""}
                                disabled={isDisabled}
                                onChange={(e) => handleChange("alertValueEnd", e.target.value)}
                                className={errors?.alertValueEnd ? "has-error" : ""}
                            />
                        </div>
                    </div>

                    <div className="grant-custom-params__inputs__wrapper">
                        <div className="grant-custom-params__inputs__wrapper-input">
                            <label>Crítico (Início)</label>
                            <input
                                type="number"
                                placeholder="Crítico"
                                value={param.criticalValueStart ?? ""}
                                disabled={isDisabled}
                                onChange={(e) => handleChange("criticalValueStart", e.target.value)}
                                className={errors?.criticalValueStart ? "has-error" : ""}
                            />
                        </div>
                        <i className="fa fa-arrow-right" />
                        <div className="grant-custom-params__inputs__wrapper-input">
                            <label>Crítico (Fim)</label>
                            <input
                                type="number"
                                placeholder="Crítico"
                                value={param.criticalValueEnd ?? ""}
                                disabled={isDisabled}
                                onChange={(e) => handleChange("criticalValueEnd", e.target.value)}
                                className={errors?.criticalValueEnd ? "has-error" : ""}
                            />
                        </div>
                    </div>

                    <div className="grant-custom-params__inputs__wrapper">
                        <div className="grant-custom-params__inputs__wrapper-input">
                            <label>Excedido (Início)</label>
                            <input
                                type="number"
                                placeholder="Excedido"
                                value={param.exceededValueStart ?? ""}
                                disabled={isDisabled}
                                onChange={(e) => handleChange("exceededValueStart", e.target.value)}
                                className={errors?.exceededValueStart ? "has-error" : ""}
                            />
                        </div>
                        <i className="fa fa-arrow-right" />
                        <div className="grant-custom-params__inputs__wrapper-input">
                            <label>Excedido (Fim)</label>
                            <input
                                type="number"
                                placeholder="Excedido"
                                value={param.exceededValueEnd ?? ""}
                                disabled={isDisabled}
                                onChange={(e) => handleChange("exceededValueEnd", e.target.value)}
                                className={errors?.exceededValueEnd ? "has-error" : ""}
                            />
                        </div>
                    </div>

                    <div className="grant-custom-params__select">
                        <label>Escala</label>
                        <Select
                            placeholder="Selecione"
                            value={param.scale}
                            options={scaleOptions}
                            disabled={isDisabled}
                            onChange={(option) => handleChange("scale", option?.value)}
                            hasError={errors?.scale}
                            resolveValueFromOptions
                            isClearable={isNew}
                        />
                    </div>
                </div>
                {!isNew && (
                    <div className="grant-custom-params__remove">
                        <ConfirmDelete
                            enabled
                            type="trash"
                            title="Excluir parâmetro"
                            action={() => onDelete(param)}
                        />
                    </div>
                )}
            </div>
            {
                isNew && (
                    <div className="grant-custom-params__add-btn">
                        <button
                            onClick={onAdd}
                            className="hdv-btn-forms hdv-btn-green"
                        >
                            Adicionar
                        </button>
                    </div>
                )
            }
        </div >
    );
}

export default CustomParamRow;